import {useState,useEffect} from 'react'

//devextreme
import notify from 'devextreme/ui/notify';

//components
import CustomSurvey from '../../assets/controls/custom-survey'

//style
import '../styles/request-list-survey.css'

//utils
import {postRequestReview} from '../../../utils/my-requests'

const RequestListSurvey = ({propertyId,requestId, optionId, loading,isReviewed}) => {
  const [propertyRate, setPropertyRate] = useState(0)
  const [photoRate, setPhotoRate] = useState(0)
  const [communicationRate, setCommunicationRate] = useState(0)
  const [priceQualityRate, setPriceQualityRate] = useState(0)
  const [surveyQualification, setSurveyQualification] = useState(0)
  const [allowUserCheck, setAllowUserCheck] = useState(false)
  const [title, setTitle] = useState(null)
  const [comment, setComment] = useState(null)

  const sendReview = async _ => 
  {
    if(photoRate > 0 && communicationRate > 0 && priceQualityRate > 0 && propertyRate > 0 && surveyQualification > 0 && title  && comment)
    {
      await postRequestReview(propertyId, requestId, optionId, surveyQualification, propertyRate, communicationRate, photoRate, priceQualityRate, title, comment, allowUserCheck)
    }
    else{
      notify('You need to add the ratings before sending the review.', "error" , 3000);
    }
  }
  
  return (
    <CustomSurvey 
      propertyRate={propertyRate}
      photoRate={photoRate}
      communicationRate={communicationRate}
      priceQualityRate={priceQualityRate}
      title={title}
      comment={comment}
      reviewed={isReviewed}
      surveyQualification={surveyQualification}
      allowUserCheck={allowUserCheck}
      setPhotoRate={setPhotoRate}
      setPropertyRate={setPropertyRate}
      setPriceQualityRate={setPriceQualityRate}
      setCommunicationRate={setCommunicationRate}
      setComment={setComment}
      setTitle={setTitle}
      setSurveyQualification={setSurveyQualification}
      setAllowUserCheck={setAllowUserCheck}
      sendReview={sendReview}
      loading={loading}
    />
  )
}

export default RequestListSurvey